module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": '转发视频:' + _vm.videoTitle,
      "width": "45%",
      "center": true,
      "visible": _vm.addVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "add-body"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "add-body-form",
    attrs: {
      "model": _vm.submitData,
      "rules": _vm.validatorRules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "add-body-div"
  }, [_c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "目标用户",
      "prop": "targetUserId"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": true,
      "placeholder": "请选择目标用户"
    },
    on: {
      "change": _vm.handleTargetUserIdChange
    },
    model: {
      value: (_vm.submitData.targetUserId),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "targetUserId", $$v)
      },
      expression: "submitData.targetUserId"
    }
  }, _vm._l((_vm.platformUserOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "add-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "转发附言",
      "prop": "transmitText"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入转发附言"
    },
    model: {
      value: (_vm.submitData.transmitText),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "transmitText", $$v)
      },
      expression: "submitData.transmitText"
    }
  })], 1)], 1)]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "video-item-view"
  }, [_c('div', {
    staticClass: "video-head"
  }, [_vm._v("\n          " + _vm._s(_vm.submitData.videoText) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "video-item"
  }, [_c('vueMiniPlayer', {
    ref: "vueMiniPlayer",
    attrs: {
      "video": _vm.submitData.videoItem,
      "mutex": true
    },
    on: {
      "fullscreen": _vm.handleFullscreen
    }
  })], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d8dad338", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8dad338"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/main/VideoTransmitView.vue
// module id = 1323
// module chunks = 1